/**
 * Exception Handler
 *
 * Adds event listeners on `window` to catch and handle specified errors.
 *
 * @example
 * // Handle specified error types
 * exception_handler.on(ErrorConstructor, callback)
 *
 * // Handle any unexpected error
 * exception_handler.on(callback)
 */
export class ExceptionHandler {
    constructor() {
        this._callbacks = new Map();
        this.handle_error = (e) => {
            const error = e instanceof ErrorEvent ? e.error : e.reason;
            const error_type = error === null || error === void 0 ? void 0 : error.constructor;
            let prevent = false;
            if (error_type) {
                const callbacks = this._callbacks.get(error_type);
                if (callbacks) {
                    callbacks.forEach(callback => {
                        const prevent_propagation = callback(error);
                        if (prevent_propagation) {
                            prevent = true;
                        }
                    });
                    if (prevent) {
                        this.prevent_error_propagation(e);
                    }
                    return;
                }
            }
            const unexpected_callbacks = this._callbacks.get('Unexpected');
            if (unexpected_callbacks) {
                unexpected_callbacks.forEach(callback => {
                    const prevent_propagation = callback(error);
                    if (prevent_propagation) {
                        prevent = true;
                    }
                });
            }
            if (prevent) {
                this.prevent_error_propagation(e);
            }
        };
        window.addEventListener('error', this.handle_error);
        window.addEventListener('unhandledrejection', this.handle_error);
    }
    on(item, callback) {
        if (arguments.length === 2 && callback) {
            this.register_callback(item, callback);
        }
        else {
            this.register_callback('Unexpected', item);
        }
    }
    dispose() {
        window.removeEventListener('error', this.handle_error);
        window.removeEventListener('unhandledrejection', this.handle_error);
    }
    prevent_error_propagation(error) {
        error.preventDefault();
        error.stopPropagation();
    }
    register_callback(error_type, callback) {
        var _a;
        if (this._callbacks.has(error_type)) {
            (_a = this._callbacks.get(error_type)) === null || _a === void 0 ? void 0 : _a.add(callback);
        }
        else {
            this._callbacks.set(error_type, new Set([callback]));
        }
    }
}
//# sourceMappingURL=ExceptionHandler.js.map